import React from "react";
import { Primary, stateBoardImages } from "./data";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import FAQ from "./commonfaq";
import { primary } from "./faqdata";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";

const title="About Our Primary School Education"
 const description="Primary school is a time when children begin to explore the world with curiosity and confidence. At Rankridge Schools, we create a nurturing environment where learning feels meaningful and enjoyable. Recognized among the best primary schools in Hyderabad near Kukatpally and Miyapur, our programme blends academics with creativity, values, and life skills.Students build strong foundations in language, mathematics, science, and social studies while also engaging in arts, sports, storytelling, and hands-on projects. This balanced approach helps children develop critical thinking, problem-solving, and collaboration skills in a natural way.Our experienced teachers guide every child with personal attention, ensuring learning is stress-free and inspiring. At Rankridge, primary education is not only about academic success but also about shaping confident, compassionate, and curious young learners."

const seopages = {
    title: "Best Primary School in Hyderabad | Rankridge School",
    description:
      "Give your child a strong academic foundation at Rankridge Primary School, Hyderabad. Expert teachers, engaging learning, and all-round personality development.",
    keywords: "Best primary school hyderabad, top primary school hyderabad, cbse primary school hyderabad, state board primary school hyderabad, primary school admissions hyderabad, rankridge primary school, primary education hyderabad, best private primary school hyderabad, primary school near me, primary schools with extracurriculars hyderabad, english medium primary school hyderabad, affordable primary school hyderabad, primary school ",
    canonical_path: "https://rankridgeschools.com/primary-school-education/",
    og_description: "",
    og_image: "",
  };


const PrimarySchool = () => {
  return (
    <div> 
      <h1 className="text-2xl text-center font-bold m-3">Rankridge Primary School in Hyderabad – Best Primary Education for Grade 1 to 5</h1>
 {/* <CommonImageSlider  images={Primary}/> */}
          <CommonAboutHeader  images={Primary} title={title} des={description}/>


     <section className="mt-4 mb-4">
     <CallandRegisterComponent />
</section>
{/* <h2 className="text-xl text-center sm:text-2xl font-semibold text-[black]   m-2">Shaping Young Minds with Knowledge, Values & Confidence – Rankridge Primary School.</h2>
 <section className="m-4">
  <h2 className="text-center text-2xl font-bold">About Rankridge Primary School</h2>
  <p className="mt-2">
    At Rankridge Primary School, we believe the foundation years are the most important stage of a child’s learning journey.
    From Grade 1 to Grade 5, we focus on nurturing curiosity, encouraging creativity, and building strong academic skills.
    Recognized as the best primary school in Hyderabad, we combine world-class teaching methods with a caring and supportive environment.
    Our goal is to help every child grow into a confident, capable, and compassionate learner.
  </p>
</section> */}

<div className="bg-[#20b2aa] text-[#0e1b3d] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-12 space-y-16">
  {/* Tagline */}
  <div className="text-center mb-8">
    <h2 className="text-xl sm:text-2xl font-semibold text-black">
      Rankridge Primary School – Shaping Bright Minds, Building Strong Futures
    </h2>
    <h3 className="text-lg sm:text-xl font-semibold text-black mt-3">
      Where Learning Meets Care, Creativity, and Excellence
    </h3>
    <p className="mt-4">
      Every parent dreams of seeing their child grow into a confident, capable, and compassionate individual. At Rankridge Primary School,
      we understand that the primary years are the foundation of a child’s lifelong learning journey. As the best primary school in Hyderabad,
      we provide an environment where curiosity is nurtured, talents are celebrated, and academic excellence blends seamlessly with creativity and values.
    </p>
  </div>

  <div className="grid grid-cols-1 lg:grid-cols-1 items-start gap-1">
    {/* World-Class Infrastructure */}
    <div className="border bg-white border-gray-300 p-2 rounded-xl">
      <h3 className="text-xl font-bold text-black">Why Parents Choose Rankridge for Primary Education?</h3>
      <h4 className="text-lg font-semibold text-black mt-3">World-Class Infrastructure</h4>
      <ul className="list-disc pl-6 mt-2">
        <li>
          Bright, spacious classrooms, child-friendly furniture, modern labs, a rich library, and interactive smartboards create an engaging learning environment.
        </li>
        <li>
          A safe and hygienic campus gives parents complete peace of mind.
        </li>
      </ul>
    </div>

    {/* Highly Qualified & Caring Teachers */}
    <div className="border bg-white border-gray-300 p-6 rounded-xl">
      <h4 className="text-lg font-semibold text-black">Highly Qualified & Caring Teachers</h4>
      <ul className="list-disc pl-6 mt-2">
        <li>
          Our faculty are mentors, motivators, and role models. Trained in child-centered methods, they ensure every child learns at their own pace while feeling valued and encouraged.
        </li>
      </ul>
    </div>

    {/* Modern & Activity-Based Learning */}
    <div className="border bg-white border-gray-300 p-6 rounded-xl">
      <h4 className="text-lg font-semibold text-black">Modern & Activity-Based Learning</h4>
      <ul className="list-disc pl-6 mt-2">
        <li>
          Learning by doing—through experiments, role-plays, field trips, and interactive projects—makes concepts easy to understand and retain while building problem-solving and creativity.
        </li>
      </ul>
    </div>

    {/* Focus on Academics + Creativity */}
    <div className="border bg-white border-gray-300 p-6 rounded-xl">
      <h4 className="text-lg font-semibold text-black">Focus on Academics + Creativity</h4>
      <ul className="list-disc pl-6 mt-2">
        <li>
          A balanced curriculum aligned with top CBSE primary standards, plus art, music, dance, sports, and coding to develop well-rounded personalities.
        </li>
      </ul>
    </div>

    {/* Safe, Nurturing, and Values-Driven Education */}
    <div className="border bg-white border-gray-300 p-6 rounded-xl">
      <h4 className="text-lg font-semibold text-black">Safe, Nurturing, and Values-Driven Education</h4>
      <ul className="list-disc pl-6 mt-2">
        <li>
          CCTV surveillance, trained staff, and strict hygiene protocols ensure safety. We instill values—respect, empathy, discipline, and teamwork—so children grow into responsible global citizens.
        </li>
      </ul>
    </div>

    {/* Laying the Foundation for Future Success */}
    <div className="border bg-white border-gray-300 p-6 rounded-xl">
      <h4 className="text-lg font-semibold text-black">Laying the Foundation for Future Success</h4>
      <ul className="list-disc pl-6 mt-2">
        <li>
          Structured learning from Grades 1–5 prepares students for higher classes with confidence. Academic rigor, practical learning, and personal care ensure readiness for future challenges.
        </li>
      </ul>
    </div>
  </div>

  {/* Admissions */}
  <div className="bg-[#f9fafb] border border-gray-300 p-6 rounded-xl">
    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-black mb-4">
      Admissions Open – Join the Rankridge Family
    </h3>
    <p className="text-base md:text-lg mb-2">
      Give your child the gift of a strong foundation, a joyful learning experience, and values for life. Enroll them at Rankridge Primary Education Hyderabad—where every child’s potential is nurtured with love, dedication, and world-class teaching.
    </p>
    <p><span className="font-semibold">📍 Location:</span> Hyderabad</p>
    <p><span className="font-semibold">📞 Call Us:</span> +91 99 59 303 873</p>
    <p><span className="font-semibold">🌐 Visit:</span> www.rankridgeschools.com</p>
  </div>
</div>

     <FAQ data={primary} />
            <SeoMeta seopages={seopages} />

    </div>
  );
};
export default PrimarySchool